export default __webpack_public_path__ + "static/media/pointarrow.c3110e88.svg";